export default "__VITE_ASSET__CXp5FWP$__"